// extracted by mini-css-extract-plugin
module.exports = {"container":"container-24Mha","subtitle":"subtitle-3TAU8","open-icon":"open-icon-2mPOu","openIcon":"open-icon-2mPOu"};